<template>
    <div :class="lengthType">
        <v-select
            v-model="selected"
            :options="options"
            label="name"
            @input="select"
            :disabled="disabled"
            :placeholder="placeholder"
        />
        <input-error v-if="v && name" :v="v" :name="name"/>
    </div>
</template>

<script>
import InputError from '../Input/InputError';

export default {
    name:       'o3Select',
    components: { InputError },
    props:      {
        v:           {
            required: false,
        },
        name:        {
            type:     String,
            required: true,
        },
        placeholder: {
            type:     String,
            required: false,
            default:  'Vyberte',
        },
        value:       {
            default: () => null,
        },
        options:     {
            type:     Array,
            required: true,
        },
        disabled:    {
            type:    Boolean,
            default: false
        },
        lengthType:  {
            type:     String,
            required: false,
            default:  () => null
        }
    },
    watch:      {
        value: function (newValue) {
            this.setValue(newValue);
        }
    },
    data() {
        return {
            selected: null,
        };
    },
    methods:    {
        select() {
            this.$emit('input', this.selected);
            this.$emit('change');
        },
        setValue(selected) {
            this.selected = selected;
        }
    }
};
</script>

<style src="vue-select/dist/vue-select.css"></style>
